export const IMAGE_MIME_TYPE_REGEX = /^image\/.*/i;
export const IMAGE_FILE_EXTENSION_REGEX =
  /\.(jpg|jpeg|gif|png|svg|bmp|eps|psd|tiff|ico|jxr|wdp)$/i;
export const IMAGE_DATA_URL_REGEX = /^data:image\//i;

export function isImageFile(file) {
  if (!file) return false;
  return (
    IMAGE_MIME_TYPE_REGEX.test(file.type || '') ||
    IMAGE_FILE_EXTENSION_REGEX.test(file.name || file.path || '')
  );
}

export function isImageDataUrl(contents) {
  return IMAGE_DATA_URL_REGEX.test(contents || '');
}
